import feature1 from "../images/benefits_1.webp";
import feature2 from "../images/benefits_5.webp";
import feature3 from "../images/benefits_4.webp";

const WHY_PARTNERS_CONTENT = [
  {
    image: feature1,
    title: "Healthcare & Medical Product Distributors",
    description:
      "Including aesthetic medicine, pharmaceuticals, and clinics with international reach.",
  },
  {
    image: feature2,
    title: "Telemedicine Platforms & Medical Service Providers",
    description:
      "With growing demand for cross-border payments, patient billing solutions, and secure financial infrastructure.",
  },
  {
    image: feature3,
    title: "E-commerce Strategists & Platform Consultants",
    description:
      "Serving cross-border merchants and dropshipping operators facing banking limitations.",
  },
  {
    image: feature2,
    title: "Business Consultants & Corporate Service Providers",
    description:
      "With networks in company formation, offshore structuring, and international business operations.",
  },
  {
    image: feature3,
    title: "High-Risk Industry Professionals",
    description:
      "Connected to iGaming, crypto, adult, sweepstakes, or nutraceutical sectors that require alternative financial solutions.",
  },
  {
    image: feature1,
    title: "Affiliate Marketing Leaders & Media Buyers",
    description:
      "Tied to networks in paid traffic, global lead generation, and performance marketing.",
  },
  {
    image: feature2,
    title: "Finance Influencers & Digital Nomad Communities",
    description:
      "Who speak to audiences of remote entrepreneurs, freelancers, and location-independent businesses.",
  },
  {
    image: feature3,
    title: "International Tax & Legal Advisors",
    description:
      "Advising clients on global structuring, compliance, and cross-border payment solutions.",
  },
  {
    image: feature1,
    title: "FX Brokers & Fintech Ecosystem Builders",
    description:
      "Ecosystem BuildersWith access to traders, payment platform providers, and global finance communities.",
  },
];

export default WHY_PARTNERS_CONTENT;
